import CityPageMosquiteras from "../components/CityPageMosquiteras";

export default function Page() {
  return (
    <CityPageMosquiteras
      name="Marbella"
      slug="marbella"
      cp="29600-29604"
      poblacion={160000}
      zonaGeo="Costa del Sol Occidental"
      lat={36.5099}
      lng={-4.8826}
      zonas={["Puerto Banús", "Nueva Andalucía", "Las Chapas", "Elviria", "San Pedro"]}
      landmarks={["Puerto Banús", "Paseo Marítimo"]}
      municipiosLimitrofes={["Ojén", "Benahavís", "Estepona", "Mijas"]}
      festivalLocal="Feria de San Bernabé (junio)"
      contextoTipologico="Villas premium con grandes ventanales que requieren mosquiteras correderas, urbanizaciones con jardines atractivos para insectos."
      isCoreZone={true}
    />
  );
}